import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Grid, IconButton, Typography, ListItem, ListItemText } from '@mui/material';
import { useState, useEffect } from 'react';
import { IJob } from 'wisestep-api';
import { WsColors, WsDrawer, WsTypography, WsTypoVariants, ScrollableTabs } from 'wisestep-base';

import { downloadJD } from '../../hooks';

type ViewDetailsDrawerProps = {
  open: boolean;
  selectTab: number;
  closeDetails: () => void;
  job: IJob;
};
const ViewDetailsDrawer = ({ open, selectTab, closeDetails, job }: ViewDetailsDrawerProps) => {
  const [tabPanelPage, setTabPanelPage] = useState(selectTab);
  const removeQuotes = (str: string): string => {
    return str.replace(/['",]+/g, '');
  };

  useEffect(() => {
    setTabPanelPage(selectTab);
  }, [selectTab]);

  return (
    <>
      {job.description && job.questions == null && (
        <WsDrawer title="" open={open} onClose={() => closeDetails()} size="medium">
          <Grid container p={2} display="flex" justifyContent="space-between">
            <Grid item xs={6}>
              <WsTypography variant={WsTypoVariants.TITLE}>Job Description</WsTypography>
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <IconButton onClick={() => downloadJD(job.id ?? '')}>
                <FileDownloadOutlinedIcon sx={{ color: WsColors.TertiaryShades500, width: 25 }} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container px={3} py={1} display="flex">
            <Grid item xs={6}>
              <WsTypography variant={WsTypoVariants.TITLE}>Eligible Visa:</WsTypography>
            </Grid>

            {job.visaRequirements && (
              <Grid item xs={6}>
                <WsTypography variant={WsTypoVariants.CAPTION}>{job.visaRequirements}</WsTypography>
              </Grid>
            )}
            <Grid item xs={6}>
              <WsTypography variant={WsTypoVariants.TITLE}>Contract Type:</WsTypography>
            </Grid>
            <Grid item xs={6}>
              {!job.jobType && <WsTypography variant={WsTypoVariants.CAPTION}> $</WsTypography>}
              {job.jobType && (
                <WsTypography variant={WsTypoVariants.CAPTION}>{job.jobType}</WsTypography>
              )}
            </Grid>
          </Grid>
          <Grid container px={3} py={1} display="flex">
            <Grid item xs={12}>
              <WsTypography variant={WsTypoVariants.TITLE}>Job Description</WsTypography>
              {job.description && (
                <Typography
                  dangerouslySetInnerHTML={{
                    __html: job.description
                      ? job.description.replace(
                          /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
                          'illegalscript'
                        )
                      : '',
                  }}
                />
              )}
            </Grid>
          </Grid>
          <Grid container px={3} py={1} display="flex">
            <Grid item xs={12}>
              <WsTypography variant={WsTypoVariants.TITLE}>Job Insights</WsTypography>
              {job.insights &&
                job.insights.length &&
                job.insights.map((insight, index) => (
                  <Typography
                    sx={{
                      wordWrap: 'break-word',
                    }}
                    key={index}
                    dangerouslySetInnerHTML={{
                      __html: insight.insight
                        ? insight.insight.replace(
                            /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
                            'illegalscript'
                          )
                        : '',
                    }}
                  />
                ))}
            </Grid>
          </Grid>
        </WsDrawer>
      )}
      {job.description && job.questions && (
        <WsDrawer title="" open={open} onClose={() => closeDetails()} size="medium">
          <ScrollableTabs
            scrollList={[
              { tabName: 'Job Description' },
              {
                tabName: 'Interview Questions',
              },
            ]}
            getTabIndex={setTabPanelPage}
            defaultValue={tabPanelPage}
          />
          {tabPanelPage === 0 && (
            <>
              <Grid container p={2} display="flex" justifyContent="space-between">
                <Grid item xs={6}>
                  <WsTypography variant={WsTypoVariants.TITLE}>Job Description</WsTypography>
                </Grid>
                <Grid item xs={6} display="flex" justifyContent="flex-end">
                  <IconButton onClick={() => downloadJD(job.id ?? '')}>
                    <FileDownloadOutlinedIcon
                      sx={{ color: WsColors.TertiaryShades500, width: 25 }}
                    />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid container px={3} py={1} display="flex">
                <Grid item xs={6}>
                  <WsTypography variant={WsTypoVariants.TITLE}>Eligible Visa:</WsTypography>
                </Grid>

                {job.visaRequirements && (
                  <Grid item xs={6}>
                    <WsTypography variant={WsTypoVariants.CAPTION}>
                      {job.visaRequirements}
                    </WsTypography>
                  </Grid>
                )}
                <Grid item xs={6}>
                  <WsTypography variant={WsTypoVariants.TITLE}>Contract Type:</WsTypography>
                </Grid>
                <Grid item xs={6}>
                  {!job.jobType && <WsTypography variant={WsTypoVariants.CAPTION}> $</WsTypography>}
                  {job.jobType && (
                    <WsTypography variant={WsTypoVariants.CAPTION}>{job.jobType}</WsTypography>
                  )}
                </Grid>
              </Grid>
              <Grid container px={3} py={1} display="flex">
                <Grid item xs={12}>
                  <WsTypography variant={WsTypoVariants.TITLE}>Job Description</WsTypography>
                  {job.description && (
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: job.description
                          ? job.description.replace(
                              /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
                              'illegalscript'
                            )
                          : '',
                      }}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid container px={3} py={1} display="flex">
                <Grid item xs={12}>
                  <WsTypography variant={WsTypoVariants.TITLE}>Job Insights</WsTypography>
                  {job.insights &&
                    job.insights.length &&
                    job.insights.map((insight, index) => (
                      <Typography
                        sx={{
                          wordWrap: 'break-word',
                        }}
                        key={index}
                        dangerouslySetInnerHTML={{
                          __html: insight.insight
                            ? insight.insight.replace(
                                /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
                                'illegalscript'
                              )
                            : '',
                        }}
                      />
                    ))}
                </Grid>
              </Grid>
            </>
          )}
          {tabPanelPage === 1 && job.questions && (
            <>
              <Grid container p={3} spacing={2} direction="column">
                <Grid item xs={6} justify-content="center">
                  <WsTypography variant={WsTypoVariants.TITLE}>
                    Interview questions for the Role of {job.title}
                  </WsTypography>
                </Grid>
                <Grid item xs={3}>
                  {job.questions.map((question, index) => (
                    <ListItem style={{ marginTop: '10px' }} key={index}>
                      <ListItemText
                        style={{ marginLeft: '20px' }}
                        primary={removeQuotes(question)}
                      />
                    </ListItem>
                  ))}
                </Grid>
              </Grid>
            </>
          )}
        </WsDrawer>
      )}
    </>
  );
};

export default ViewDetailsDrawer;
